import {forwardRef} from 'react';
import cx from 'classnames';
import Image from 'next/image';

import {Button, Card, Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';
import {getFormattedDateRange} from '#util';

import {QuestionIntroCardProps} from './QuestionIntroCard.types';

import * as css from './QuestionIntroCard.css';

/**
 * This component renders an introductory card for a stack of QuestionCards, and
 * is primarily used on the Check-in page.
 */
export const QuestionIntroCard = forwardRef<HTMLDivElement, QuestionIntroCardProps>(
  (
    {
      className = '',
      endedOn = '',
      headline = 'Complete your weekly check-in',
      imageUrl = '/image/action-plan.jpg',
      startedOn = '',
      ...otherProps
    },
    ref,
  ) => (
    <Card className={cx(css.root, className)} ref={ref} variant="deepBurgundy" {...otherProps}>
      <Image
        alt=""
        aria-hidden
        className={sprinkles({pos: 'absolute', inset: 0})}
        layout="fill"
        objectFit="cover"
        objectPosition="55%"
        src={imageUrl}
      />

      <div className={css.contentWrapper}>
        <Text as="p" className={css.pill} color="ecruWhite" variant="caption">
          {getFormattedDateRange(startedOn, endedOn)}
        </Text>

        <div
          className={sprinkles({
            content: 'between',
            flex: 'flex',
            gap: [4, 64, 8],
            items: 'start',
          })}>
          <Text as="h2" color="ecruWhite" variant="heading2">
            {headline}
          </Text>

          <Button className={sprinkles({mT: 8})} icon="ArrowRight" />
        </div>
      </div>
    </Card>
  ),
);
